import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setHomeownerOnboardingFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const sortingFAQSHomeOwnerOnboardingFormData = (state, { payload }) => {
  let data = state.data.faqs.map((faq) => {
    if(faq.id === payload[0].id) {
      return payload[1]
    } else if(faq.id === payload[1].id) {
      return payload[0]
    } else {
      return faq
    }
  });
  
  return {
    ...state,
    data: {
      ...state.data, faqs: data,
      ...payload
    },
  };
}
const clearsetHomeownerOnboardingFormData = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.HOMEOWNER_ONBOARDING_FORM_DATA]: setHomeownerOnboardingFormData,
  [TYPES.CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA]: clearsetHomeownerOnboardingFormData,
  [TYPES.SORTING_FAQS_HOMEOWNER_ONBOARDING_DATA]: sortingFAQSHomeOwnerOnboardingFormData
});
